module.exports = __webpack_public_path__ + "Benny Ho-5103aa38.png";